import React from 'react';

import './styles.css';

export default function ProjectCard(props) {
    return(
        <div className="projectcard-container">
            <div className="projectcard-content">
                <header>
                    <h2>
                        { props.content.title }
                    </h2>
                </header>
                <main>
                    <p>
                        { props.content.description }
                    </p>
                </main>
                <footer>
                    <a 
                        className="projectcard-btn-more" 
                        href={ props.content.link } 
                        target="_blank"
                    >
                        Saiba mais
                    </a>
                </footer>
            </div>
        </div>
    );
}